import { AfterViewInit, Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Result, parseError } from '../../../shared/interfaces';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiService } from "src/app/api/api.service";
import { CoreService } from "src/app/services/core-service/core-service.service";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { isNil } from "lodash-es";
import { environment } from "src/environments/environment";
import { ESTADOS_SITIO } from "src/app/shared/constantes";
import { DOCUMENT } from "@angular/common";
import { freeSet } from "@coreui/icons";
import { Meta, Title } from '@angular/platform-browser';


@Component({
    selector: 'perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit, AfterViewInit, OnChanges {
    icons = freeSet;
    private _urlActual = '';
    private _id: number = -1;
    private _imagenPerfil: string = '';
    private urlBase: string = '';
    private config: any = null;
    @Input() sinCarrusel: boolean = false;
    @Input() buscarPerfil: boolean = true;
    @Input() esAdministrador: boolean = false;
    formulario = new FormGroup({
        id: new FormControl(),
        imagen: new FormControl(),
        nombre: new FormControl('', { validators: [Validators.required] }),
        apellido: new FormControl('', { validators: [Validators.required] }),
        departamento: new FormControl('Guatemala', { validators: [Validators.required] }),
        categoria_id: new FormControl(0, Validators.required),
        categoria: this.fb.group({
            id: new FormControl(null),
            nombre: new FormControl(''),
            imagen: new FormControl()
        }),
        descripcion: new FormControl('', Validators.required),
        descripcion_larga: new FormControl('', Validators.required),
        votos: new FormControl(null),
        profesion: new FormControl('', Validators.required),
        periodo_id: new FormControl(null, Validators.required),
        estado_id: new FormControl(null),
        estado: this.fb.group({
            id: new FormControl(),
            descripcion: new FormControl()
        }),
        ganador: new FormControl(0),
        finalista: new FormControl(0),
        RedSocialPerfil: this.fb.array([
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(1),
                redSocial: new FormControl('Facebook'), //Facebook
                ConfRedesSociable: this.fb.group({
                    id: new FormControl(),
                    nombre: new FormControl(),
                    imagen: new FormControl(),
                })
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(2),
                redSocial: new FormControl('LinkedIn'),
                ConfRedesSociable: this.fb.group({
                    id: new FormControl(),
                    nombre: new FormControl(),
                    imagen: new FormControl(),
                })
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(3),
                redSocial: new FormControl('Instagram'),
                ConfRedesSociable: this.fb.group({
                    id: new FormControl(),
                    nombre: new FormControl(),
                    imagen: new FormControl(),
                })
            }),
            this.fb.group({
                perfil_id: new FormControl(null),
                link: new FormControl(null, Validators.required),
                red_social_id: new FormControl(4),
                redSocial: new FormControl('Twitter'),
                ConfRedesSociable: this.fb.group({
                    id: new FormControl(),
                    nombre: new FormControl(),
                    imagen: new FormControl(),
                })
            })
        ]),
        LogrosPerfil: this.fb.array([
            this.fb.group({
                id: null,
                perfil_id: null,
                logro: '',
                holder: 'Ejemplo: Generó trabajo para 120 familias en Alta Verapaz durante el año 2018.'
            })
        ]),
        desarrollo_carrera: new FormControl(null, Validators.required),
        personas_beneficiadas: new FormControl(null, Validators.required),
        grupo_politico_religioso: new FormControl(null, Validators.required),
        correo: new FormControl(null, Validators.required),
        telefono: new FormControl(null, Validators.required),
        created_at: new FormControl(),
        updated_at: new FormControl(),
        correo_solicitante: new FormControl(null, Validators.required),
        nombre_solicitante: new FormControl(null, Validators.required),
        telefono_solicitante: new FormControl(null, Validators.required),
        aceptar_terminos: new FormControl(null, Validators.required)
    });

    constructor(
        private fb: FormBuilder,
        private readonly api: ApiService,
        private readonly core: CoreService,
        private readonly activatedRoute: ActivatedRoute,
        protected router: Router,
        @Inject(DOCUMENT) document: any,
        private readonly meta: Meta,
        private readonly titleService: Title
    ) {
        this.urlBase = environment.apiUrl;
        this.router.events.subscribe((ev) => {
            if (ev instanceof NavigationEnd) {
                this._id = this.activatedRoute.snapshot.params['id'];
                if (!isNil(this._id)) {
                    this.buscar();
                }
            }
        });
        this._urlActual = (document.location.href).replace(/(^\w+:|^)\/\//, '');
    }

    ngAfterViewInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        this.cargarImagenActual();
    }

    ngOnInit(): void {
        if (!this.buscarPerfil) {
            return;
        }
        this._id = this.activatedRoute.snapshot.params['id'];
        if (!isNil(this._id)) {
            this.buscar();
        } else {
            this.router.navigate(['/dashboard/nominados/lista'])
        }
        this.configuracion();
    }

    setMetaTags(perfil: any) {
        this.titleService.setTitle(`${perfil.nombre} ${perfil.apellido || ''} - Guatemaltecos Ilustres`);
        this.meta.updateTag({ name: 'description', content: perfil.descripcion_corta ?? perfil.descripcion_larga });
        this.meta.addTags([
            { property: 'og:title', content: `${perfil.nombre} ${perfil.apellido || ''}` },
            { property: 'og:description', content: perfil.descripcion_corta ?? perfil.descripcion_larga },
            { property: 'og:image', content: this.imagenPerfil },
            { property: 'og:url', content:  this.router.url },
            { name: 'twitter:card', content: `${perfil.nombre} ${perfil.apellido || ''} - Guatemaltecos Ilustres` },
        ]);
    }

    async configuracion() {
        try {
            const path = 'configuracion/actual'
            const result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result;
            this.config = result.data;
        } catch (e) {
            console.log(parseError(e));
        }
    }

    async agregarLogros(listadoLogros: any[], perfilId: number) {
        const logros = this.formulario.get('LogrosPerfil') as FormArray;
        logros.clear();
        if (listadoLogros.length > 0) {
            listadoLogros.forEach(logro => {
                logros.push(this.fb.group({
                    id: logro.id,
                    perfil_id: logro.perfil_id,
                    logro: logro.logro,
                    holder: 'Ejemplo: Generó trabajo para 120 familias en Alta Verapaz durante el año 2018.'
                }));
            });
        }
    }

    async buscar() {
        try {
            this.core.lock()
            const path = `nominado/url/${this._id}`
            const result = (await this.api.consulta(path, true, [], null, 'GET')).data as Result;
            if (result.data.estado_id != 3 && !this.esAdministrador) {
                this.router.navigate(['/']);
                return;
            }
            this.formulario.patchValue(result.data)
            this.agregarLogros(result.data.LogrosPerfil, result.data.id)
            this.cargarImagenActual();
            this.setMetaTags(result.data);
        } catch (e) {
            //this.ntf.error(`Error: ${parseError(e)}`)
        } finally {
            this.core.unlock()
        }
    }

    cargarImagenActual(): void {
        const imagFormulario = this.formulario.value.imagen;
        if (isNil(imagFormulario)) {
            return;
        }
        this._imagenPerfil = `${this.urlBase}/uploads/${imagFormulario}`
    }

    compartirPorWhatsApp() {
        const texto = `Vota por ${this.formulario.value.nombre} ${this.formulario.value.apellido}`
        const textoCodificado = encodeURIComponent(texto);
        const urlCodificada = encodeURIComponent(this._urlActual);
        const enlaceWhatsApp = `https://wa.me/?text=${textoCodificado}%20${urlCodificada}`;

        // Abrir la aplicación de WhatsApp con el enlace generado
        window.open(enlaceWhatsApp, '_blank');
    }

    get perfil(): any {
        return this.formulario.getRawValue();
    }

    @Input() set perfil(value: any) {
        this.formulario = value;
    }

    get nominacionesExtras(): string {
        return `Más Votados ${this.perfil?.categoria?.nombre}`;
    }

    get imagenPerfil(): string {
        const imagFormulario = this.formulario.value.imagen;
        if (isNil(imagFormulario)) {
            return '';
        }
        return `${this.urlBase}/uploads/${imagFormulario}`
    }

    get listadoLogros(): any[] {
        return this.formulario.value.LogrosPerfil?.filter(logro => !isNil(logro.id) && (!isNil(logro.logro)) && logro.logro.length > 0) || []
    }

    get redesSociales(): any[] {
        return this.formulario.value.RedSocialPerfil?.filter(red => !isNil(red.link) && red.link !== '') || []
    }

    get habilitarVotar(): boolean {
        return this.config?.periodo_actual_id === this.formulario.value.periodo_id && this.config?.estado_sitio_id === ESTADOS_SITIO.NOMINAR_VOTAR;
    }

    get mostrarCarrusel(): boolean {
        return this.config?.estado_sitio_id != ESTADOS_SITIO.GANADORES && this.config?.estado_sitio_id != ESTADOS_SITIO.FINALISTAS
    }

    get urlActual(): string {
        return this._urlActual;
    }

    get descripcionLarga(): string {
        return !isNil(this.formulario.value.descripcion_larga) ? this.formulario.value.descripcion_larga.replace(/\n/g, '<br>') : '';
    }

    get noEsPerfilGanador(): boolean {
        return this.formulario.value.ganador == 1 || this.formulario.value.finalista == 1;
    }
}